import { useContext } from 'react';

import type { ThemeContextType } from '../context/ThemeContext';
import ThemeContext from '../context/ThemeContext';

const useThemeContext: () => ThemeContextType = () => useContext(ThemeContext);
interface UseThemeType extends ThemeContextType {
  isDark: boolean;
}

const useTheme = (): UseThemeType => {
  const { theme, setTheme } = useThemeContext();

  const isDark = theme === 'dark';

  return {
    theme,
    setTheme,
    isDark,
  };
};

export default useTheme;
